import React from "react";
import { Container, Grid, List } from "semantic-ui-react";

import serviceimg from "../../static/converted/service-min.jpg";

import Imgmodal from "../imgmodal";

const Service = () => (
  <Container id="service" className="main_content">
    <h1>Was wir unseren Kunden bieten, ist am ganzen Fluss Po einmalig.</h1>
    <Grid centered columns={2} stackable>
      <Grid.Column>
        <List bulleted>
          <List.Item>Mext-Leihboote in 3 verschieden Klassen</List.Item>
          <List.Item>
            Hauptberufliche Angelguides, alle samt mit langjähriger Fluss Po
            Erfahrung
          </List.Item>
          <List.Item>
            Exklusive Guiding-Angebote auf Waller und andere Fischarten
          </List.Item>
          <List.Item>
            Italienisches Restaurante mit Früh/Mittag und Abendessen
          </List.Item>
          <List.Item>Angellizenzen direkt vor Ort zu Erwerben</List.Item>
          <List.Item>Alarmgesicherter Parkplatz</List.Item>
          <List.Item>Mehrere sanitäre Anlagen</List.Item>
          <List.Item>Hochwertiges Angelleihgerät</List.Item>
          <List.Item>1.200 qm Bootshalle</List.Item>
          <List.Item>Köderfisch Service</List.Item>
          <List.Item>Zeltplatz</List.Item>
          <List.Item>Mechaniker</List.Item>
          <List.Item>Kühlschränke</List.Item>
          <List.Item>Krahnanlage</List.Item>
          <List.Item>Steganlage</List.Item>
          <List.Item>Cocktailbar</List.Item>
          <List.Item>W-Lan</List.Item>
          <List.Item>und vieles mehr!!!</List.Item>
        </List>
      </Grid.Column>
      <Grid.Column>
        <Imgmodal img={serviceimg} size="medium" />
      </Grid.Column>
    </Grid>
  </Container>
);

export default Service;



// WEBPACK FOOTER //
// ./src/components/Service/index.js